export default __webpack_public_path__ + "static/media/404.53ed2f44.md";